import { render, staticRenderFns } from "./AppOrderDetails.vue?vue&type=template&id=788a38c7&scoped=true&"
import script from "./AppOrderDetails.vue?vue&type=script&lang=js&"
export * from "./AppOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./AppOrderDetails.vue?vue&type=style&index=0&id=788a38c7&prod&lang=scss&scoped=true&"
import style1 from "./AppOrderDetails.vue?vue&type=style&index=1&id=788a38c7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788a38c7",
  null
  
)

export default component.exports